<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<h2 class="fm-title0"><span class="bold">DEDICATION</span></h2>
<p class="ded">The author dedicates this work to the many kind folks of Wikimedia Commons that contributed photographs for unlimited use with only appropriate credit required. The author would like to give a special note of appreciation to Alan Wilson, many of whose images grace this work.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?1d054e64